import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, vModelSelect as _vModelSelect, vModelText as _vModelText, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "Not Available")
], -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "Not Available")
], -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = {
  key: 0,
  class: "big-text"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-comment-dots text-info" }, null, -1 /* HOISTED */)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 4,
  class: "text-end"
}
const _hoisted_17 = {
  key: 0,
  type: "button",
  class: "btn table-btn btn-outline-info me-1"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip icon-size" }, null, -1 /* HOISTED */)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 5,
  colspan: "4"
}
const _hoisted_23 = {
  key: 0,
  class: "transfer-form-row-one"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "Not Available")
], -1 /* HOISTED */)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "text-default" }, "Not Available")
], -1 /* HOISTED */)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = {
  key: 0,
  class: "big-text"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-comment-dots text-info" }, null, -1 /* HOISTED */)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "big-text" }, [
    /*#__PURE__*/_createElementVNode("i", null, "Refer In Progress")
  ])
], -1 /* HOISTED */)
const _hoisted_41 = { class: "transfer-form-row-two edit-row" }
const _hoisted_42 = {
  colspan: "12",
  class: "p-3 edit au-target"
}
const _hoisted_43 = { class: "row mx-2 d-flex justify-content-center px-3 pt-3" }
const _hoisted_44 = { class: "form-group col-lg-2 ps-lg-0 me-lg-3 col-md-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "task-name" }, " Refer To: ", -1 /* HOISTED */)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Solution", -1 /* HOISTED */)
const _hoisted_48 = ["value"]
const _hoisted_49 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_50 = { class: "form-group col-lg-2 col-md-3" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { for: "task-name" }, "Branch: ", -1 /* HOISTED */)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_53 = ["disabled"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("option", { value: "null" }, "Select Branch", -1 /* HOISTED */)
const _hoisted_55 = ["label", "value"]
const _hoisted_56 = ["value"]
const _hoisted_57 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_58 = { class: "row mx-2 px-3 pb-2" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { for: "non-admit-date" }, " Non-Admit Date: ", -1 /* HOISTED */)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_61 = { class: "input-group date datepickerInput" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_64 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { for: "non-admit-reason" }, " Non-Admit Reason: ", -1 /* HOISTED */)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_67 = ["disabled"]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Non-Admit Reason", -1 /* HOISTED */)
const _hoisted_69 = ["value"]
const _hoisted_70 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_71 = { class: "text-center pt-3 pb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_FormatName = _resolveComponent("FormatName")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (!_ctx.showTransferForm && _ctx.patient)
    ? (_openBlock(), _createElementBlock("tr", {
        key: 0,
        class: _normalizeClass(`${_ctx.isDeleteRequested ? 'edit-row' : ''}`)
      }, [
        _createElementVNode("td", null, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.formatDateFromDate(_ctx.patient.created)
          }, null, 8 /* PROPS */, ["text"]),
          _hoisted_1
        ]),
        (_ctx.patient.firstName)
          ? (_openBlock(), _createElementBlock("td", _hoisted_2, [
              _createVNode(_component_FormatName, {
                "first-name": _ctx.patient.firstName,
                "last-name": _ctx.patient.lastName
              }, null, 8 /* PROPS */, ["first-name", "last-name"])
            ]))
          : (_openBlock(), _createElementBlock("td", _hoisted_3, _hoisted_5)),
        _createElementVNode("td", null, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.patient.agencyBranch
          }, null, 8 /* PROPS */, ["text"])
        ]),
        (
                _ctx.patient.serviceLine &&
                (_ctx.patient.serviceLine === _ctx.ApplicationEnum.AgencyCore ||
                    _ctx.patient.serviceLine === _ctx.ApplicationEnum.HomeCare ||
                    _ctx.patient.serviceLine === _ctx.ApplicationEnum.AxxessPalliative ||
                    _ctx.patient.serviceLine === _ctx.ApplicationEnum.AxxessHospice ||
                    _ctx.patient.serviceLine === _ctx.ApplicationEnum.AxxessHospiceFE)
            )
          ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
              _createVNode(_component_EmptyTextHandler, {
                text: _ctx.getApplicableService(_ctx.patient.serviceLine)
              }, null, 8 /* PROPS */, ["text"])
            ]))
          : (_openBlock(), _createElementBlock("td", _hoisted_7, _hoisted_9)),
        _createElementVNode("td", null, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.patient.referralType ? _ctx.patient.referralType : 'External Referral'
          }, null, 8 /* PROPS */, ["text"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.patient.dateOfBirth ? _ctx.formatDateFromDate(_ctx.patient.dateOfBirth) : null
          }, null, 8 /* PROPS */, ["text"]),
          _hoisted_10
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_EmptyTextHandler, {
            text: _ctx.patient.branchName
          }, null, 8 /* PROPS */, ["text"])
        ]),
        _createElementVNode("td", _hoisted_11, [
          (_ctx.patient?.comments?.length > 0)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14)), [
                [_directive_tooltip, { title: _ctx.patient.comments }]
              ])
            : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                _createVNode(_component_EmptyTextHandler, {
                  text: _ctx.patient?.comments
                }, null, 8 /* PROPS */, ["text"])
              ]))
        ]),
        (!_ctx.isDeleteRequested)
          ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
              (_ctx.patient.status == null || _ctx.listOfStatuses.includes(_ctx.patient.status))
                ? (_openBlock(), _createElementBlock("button", _hoisted_17, [
                    _createElementVNode("i", {
                      class: "fas fa-edit",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleShowTransferForm()))
                    })
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.patient.assetId != _ctx.defaultAssetId)
                ? _withDirectives((_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn table-btn px-2 btn-outline-info au-target",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadExternalRefrral()))
                  }, _hoisted_19)), [
                    [_directive_tooltip, { title: 'Download Document', placement: 'bottom' }]
                  ])
                : _createCommentVNode("v-if", true),
              (_ctx.patient.isActive)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "btn table-btn btn-outline-danger",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmDeleteReferral()))
                  }, _hoisted_21))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.isDeleteRequested)
          ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
              _createVNode(_component_TablePrompt, {
                "ok-text": "delete",
                name: "Referral",
                isInProgress: _ctx.isDeleteInProgress,
                ok: _ctx.deleteReferral,
                cancel: _ctx.cancelDeleteReferral
              }, null, 8 /* PROPS */, ["isInProgress", "ok", "cancel"])
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (_ctx.patient)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
              _createElementVNode("td", null, [
                _createVNode(_component_EmptyTextHandler, {
                  text: _ctx.formatDateFromDate(_ctx.patient.created)
                }, null, 8 /* PROPS */, ["text"]),
                _hoisted_24
              ]),
              (_ctx.patient.firstName)
                ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                    _createVNode(_component_FormatName, {
                      "first-name": _ctx.patient.firstName,
                      "last-name": _ctx.patient.lastName
                    }, null, 8 /* PROPS */, ["first-name", "last-name"]),
                    _hoisted_26
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_27, _hoisted_29)),
              _createElementVNode("td", null, [
                _createVNode(_component_EmptyTextHandler, {
                  text: _ctx.patient.agencyBranch
                }, null, 8 /* PROPS */, ["text"])
              ]),
              (
                    _ctx.patient.serviceLine &&
                    (_ctx.patient.serviceLine === _ctx.ApplicationEnum.AgencyCore ||
                        _ctx.patient.serviceLine === _ctx.ApplicationEnum.HomeCare ||
                        _ctx.patient.serviceLine === _ctx.ApplicationEnum.AxxessPalliative ||
                        _ctx.patient.serviceLine === _ctx.ApplicationEnum.AxxessHospice ||
                        _ctx.patient.serviceLine === _ctx.ApplicationEnum.AxxessHospiceFE)
                )
                ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                    _createVNode(_component_EmptyTextHandler, {
                      text: _ctx.getApplicableService(_ctx.patient.serviceLine)
                    }, null, 8 /* PROPS */, ["text"])
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_31, _hoisted_33)),
              _createElementVNode("td", null, [
                _createVNode(_component_EmptyTextHandler, {
                  text: _ctx.patient.referralType ? _ctx.patient.referralType : 'External Referral'
                }, null, 8 /* PROPS */, ["text"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_EmptyTextHandler, {
                  text: _ctx.patient.dateOfBirth ? _ctx.formatDateFromDate(_ctx.patient.dateOfBirth) : null
                }, null, 8 /* PROPS */, ["text"]),
                _hoisted_34
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_EmptyTextHandler, {
                  text: _ctx.patient.branchName
                }, null, 8 /* PROPS */, ["text"])
              ]),
              _createElementVNode("td", _hoisted_35, [
                (_ctx.patient?.comments?.length > 0)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38)), [
                      [_directive_tooltip, { title: _ctx.patient.comments }]
                    ])
                  : (_openBlock(), _createElementBlock("span", _hoisted_39, [
                      _createVNode(_component_EmptyTextHandler, {
                        text: _ctx.patient?.comments
                      }, null, 8 /* PROPS */, ["text"])
                    ]))
              ]),
              _hoisted_40
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("tr", _hoisted_41, [
          _createElementVNode("td", _hoisted_42, [
            _createVNode(_component_FormSection, null, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _hoisted_46,
                    _withDirectives(_createElementVNode("select", {
                      id: "task-name",
                      class: "form-select",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referTo) = $event)),
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateBranches(_ctx.referTo.id))),
                      onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.referTo.$touch && _ctx.v$.referTo.$touch(...args)))
                    }, [
                      _hoisted_47,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referableAgencyServices, (agency, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: agency
                        }, [
                          _withDirectives(_createElementVNode("div", null, _toDisplayString(agency.name), 513 /* TEXT, NEED_PATCH */), [
                            [_vShow, agency.show]
                          ])
                        ], 8 /* PROPS */, _hoisted_48))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                      [_vModelSelect, _ctx.referTo]
                    ]),
                    (_ctx.v$.referTo.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Field is required."))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _hoisted_52,
                    _withDirectives(_createElementVNode("select", {
                      id: "task-name",
                      class: "form-select",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedBranch) = $event)),
                      disabled: !_ctx.referTo,
                      onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$.selectedBranch.$touch && _ctx.v$.selectedBranch.$touch(...args)))
                    }, [
                      _hoisted_54,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.providerList, (provider) => {
                        return (_openBlock(), _createElementBlock("optgroup", {
                          label: provider.name,
                          value: provider,
                          key: provider.name
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provider.branches, (branch) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: branch.name,
                              value: branch
                            }, _toDisplayString(branch.name), 9 /* TEXT, PROPS */, _hoisted_56))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 8 /* PROPS */, _hoisted_55))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_53), [
                      [_vModelSelect, _ctx.selectedBranch]
                    ]),
                    (_ctx.v$.selectedBranch.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_57, "Field is required."))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`form-group ps-lg-4 pe-lg-5 col-md-3 ${
                                    !_ctx.isNonAdmit == true ? 'd-none' : 'd-block'
                                }`)
                  }, [
                    _hoisted_59,
                    _hoisted_60,
                    _createVNode(_component_DatePicker, { getDate: _ctx.updateNonAdmitDate }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_61, [
                          _withDirectives(_createElementVNode("input", {
                            name: "nonAdmitDate",
                            type: "text",
                            class: "form-control",
                            placeholder: "MM/DD/YYYY",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.nonAdmitDate) = $event)),
                            autocomplete: "off",
                            disabled: !_ctx.isNonAdmit,
                            onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.nonAdmitDate.$touch && _ctx.v$.nonAdmitDate.$touch(...args)))
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_62), [
                            [_vModelText, _ctx.nonAdmitDate]
                          ]),
                          _hoisted_63
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["getDate"]),
                    (_ctx.v$.nonAdmitDate.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_64, "Field is required."))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */),
                  _createElementVNode("div", {
                    class: _normalizeClass(`form-group col-lg-2 ps-lg-0 col-md-3 ${
                                    !_ctx.isNonAdmit == true ? 'd-none' : 'd-block'
                                }`)
                  }, [
                    _hoisted_65,
                    _hoisted_66,
                    _withDirectives(_createElementVNode("select", {
                      id: "non-admit-reason",
                      class: "form-select",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedNonAdmitReason) = $event)),
                      disabled: !_ctx.isNonAdmit,
                      onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.v$.nonAdmitDate.$touch && _ctx.v$.nonAdmitDate.$touch(...args)))
                    }, [
                      _hoisted_68,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nonAdmitReasons, (nonAdmitReason) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: nonAdmitReason.name,
                          value: nonAdmitReason
                        }, _toDisplayString(nonAdmitReason.name), 9 /* TEXT, PROPS */, _hoisted_69))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_67), [
                      [_vModelSelect, _ctx.selectedNonAdmitReason]
                    ]),
                    (_ctx.v$.selectedNonAdmitReason.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_70, "Field is required."))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */)
                ])
              ]),
              _: 1 /* STABLE */
            }),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-md au-target",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.convertToRefer())),
                "au-target-id": "2039"
              }, " Refer "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-secondary btn-md ms-2 au-target",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.closeNonAdmitForm())),
                "au-target-id": "2040"
              }, " Cancel ")
            ])
          ])
        ])
      ], 64 /* STABLE_FRAGMENT */))
}